export function toFixed(value?: string | number): number {
  if (value === undefined || value === null || value === "") {
    return 0;
  }

  const num = typeof value === "string" ? Number(value) : value;

  if (Number.isNaN(num)) {
    return 0;
  }

  return Math.round(num * 100) / 100;
}

export function toFixedDisplay(value?: string | number): string {
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(toFixed(value));
}
